import React from "react";
import NumberContainer from "./NumberContainer";

export default function Calculator() {
  return (
    <div className="calculator">
      <NumberContainer />
    </div>
  );
}
